import { log, PREFIX_STR } from '..';
import { addCache, getCache } from '../../../../lib';
import { FieldOptSource, IConfigField, IFieldOpt } from '../../model';

// 缓存 key
const getApiKey = (key: string) => {
  if (!key.trim()) {
    throw new Error(`${PREFIX_STR} Cache key cannot be empty!`);
  }
  return `AUTO_TABLE_API_CACHE-${key.trim()}`;
};

const getCacheApi = <T>(fieldConfig: IConfigField<T>) => {
  const key = getApiKey(fieldConfig.key);
  return getCache<IFieldOpt>(key);
};

export const setCacheApi = <T>(fieldConfig: IConfigField<T>) => {
  if (!fieldConfig.fieldOptExtension) {
    return;
  }
  const key = getApiKey(fieldConfig.key);
  addCache<IFieldOpt>(
    key,
    JSON.parse(JSON.stringify(fieldConfig.fieldOptExtension))
  );
};

// 是否命中 api 缓存
// 命中规则：请求参数、URL一致则不请求
export const isHitApiCacheRule = <T>(fieldConfig: IConfigField<T>) => {
  if (!fieldConfig.fieldOptExtension) {
    return false;
  }
  const cacheFieldConfig = getCacheApi(fieldConfig);
  if (!cacheFieldConfig) {
    return false;
  }

  const { fieldOptExtension } = fieldConfig;
  if (
    FieldOptSource.api === cacheFieldConfig.kind &&
    fieldOptExtension.kind === FieldOptSource.api
  ) {
    try {
      if (
        JSON.stringify(fieldOptExtension.api) ===
        JSON.stringify(cacheFieldConfig.api)
      ) {
        return true;
      }
    } catch (err) {
      log.error(err);
    }
  }
  return false;
};
